import { ConnectionIcon } from './ConnectionIcon';

interface ConnectionBadgeProps {
  connection: string;
  label?: string;
  showIcon?: boolean;
}

export function ConnectionBadge({ connection, label = connection, showIcon = true }: ConnectionBadgeProps) {
  const type = connection.toLowerCase().replace(/[^a-z]+/g, '-').replace(/^-|-$/g, '');
  return <span className={`connection-badge connection-${type}`}>{showIcon && <ConnectionIcon connection={connection} />}<span>{label}</span></span>;
}
